import { Link } from '@tanstack/react-router'
import { useGroups } from '../api/hooks'
import type { GroupListItem } from '../api/types'
import { ScreenShell } from '../components/ScreenShell'
import { Pill, ScorePad, ScorePadRow, TopBar } from '../primitives'

export const GroupsScreen = () => {
  const groups = useGroups()

  return (
    <ScreenShell active="groups">
      <TopBar title="Groups" />

      <div style={{ padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {groups.isLoading && (
          <div className="felt-card" style={{ padding: 14, color: 'var(--ink-3)', fontSize: 13 }}>
            Loading…
          </div>
        )}

        {groups.data?.length === 0 && (
          <div className="felt-card" style={{ padding: 14, color: 'var(--ink-2)' }}>
            <div style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 18 }}>
              No groups yet.
            </div>
            <div style={{ marginTop: 4, fontSize: 13 }}>
              Start a group for your regular table to track plays and ratings together.
            </div>
          </div>
        )}

        {groups.data && groups.data.length > 0 && (
          <ScorePad>
            {groups.data.map((g) => (
              <GroupRow key={g.id} group={g} />
            ))}
          </ScorePad>
        )}

        <NewGroupCard />
      </div>
    </ScreenShell>
  )
}

const GroupRow = ({ group }: { group: GroupListItem }) => (
  <Link
    to="/group/$id"
    params={{ id: group.id }}
    style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}
  >
    <ScorePadRow>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink)' }}>{group.name}</div>
        {group.description && (
          <div
            style={{
              fontSize: 11,
              color: 'var(--ink-3)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {group.description}
          </div>
        )}
      </div>
      {group.role === 'admin' && <Pill color="gilt">admin</Pill>}
      <span style={{ color: 'var(--ink-3)' }}>→</span>
    </ScorePadRow>
  </Link>
)

const NewGroupCard = () => (
  <Link
    to="/group/new"
    className="felt-card"
    style={{
      padding: 14,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      color: 'inherit',
      textDecoration: 'none',
      borderStyle: 'dashed',
    }}
  >
    <div
      aria-hidden
      style={{
        width: 44,
        height: 44,
        borderRadius: 6,
        border: '1.5px dashed var(--terra)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--terra)',
        fontSize: 24,
        fontWeight: 600,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      +
    </div>
    <div style={{ flex: 1, fontWeight: 600, fontSize: 15, color: 'var(--terra)' }}>
      Create a new group
    </div>
  </Link>
)
